<div class="bold f16 my16" i18n="@@Connection">Connection</div>
